import React from 'react';
import {
    MdOutlineExplore,
    MdOutlineSell,
    MdOutlineHomeWork,
    MdStarRate,
} from 'react-icons/md';
import { FcGoogle } from 'react-icons/fc';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import {
    dispatchTrackingEvent,
    HOMEPAGE_SEARCH_QUICK_LINK_CLICK,
    QUICK_MENU_CLICK,
    HOMEPAGE_AI_SEARCH_BUTTON,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
import DragScrollWrapper from '@PROJECT_ROOT/assets/responsive-frontend/parts/DragScrollWrapper/DragScrollWrapper';

export default function HomeIntro({ data, children }) {
    const trackMenuClick = (menuItemName) => {
        if (!IS_FRAME_SERVICE) {
            dispatchTrackingEvent(QUICK_MENU_CLICK, { menuName: menuItemName });
            if (menuItemName === 'Accommodation') {
                dispatchTrackingEvent(HOMEPAGE_SEARCH_QUICK_LINK_CLICK);
            }
            if (menuItemName === 'AI Search') {
                dispatchTrackingEvent(HOMEPAGE_AI_SEARCH_BUTTON);
            }
        }
    };

    return (
        <div className="home-intro">
            <div className="home-intro__content-top">
                <div className="home-intro__content-top-left-wrap">
                    <div className="home-intro__content-top-left">
                        <p className="home-intro__additional-text">
                            {data.text}
                        </p>
                        <h1 className="home-intro__heading">
                            {data.heading}
                        </h1>
                        <div className="home-intro__google-reviews">
                            <span className="home-intro__google-reviews-upper">
                                <FcGoogle className="home-intro__google-reviews-icon" size="16" />
                                <span className="home-intro__google-reviews-text">
                                    <span className="home-intro__google-reviews-rating">
                                        {data.google.grade}
                                    </span>
                                    <span className="home-intro__google-reviews-count">
                                        ({data.google.title})
                                    </span>
                                </span>
                            </span>
                            <span className="home-intro__google-reviews-stars">
                                {Array.from({ length: 5 }, (_, index) => <MdStarRate key={index} className="home-intro__google-reviews-stars-icon" />)}
                            </span>
                        </div>
                    </div>
                    <DragScrollWrapper
                        className="home-intro__quick-links"
                        horizontal={true}
                        vertical={false}
                    >
                        <a href={data.quickLinks[0].hyperlink.redirectURL} className="home-intro__quick-link" onClick={() => trackMenuClick('Accommodation')}>
                            <MdOutlineHomeWork size="20" className="home-intro__quick-link-icon" aria-label={data.quickLinks[0].hyperlink.seoTitle} />
                            <span className="home-intro__quick-link-text">{data.quickLinks[0]?.hyperlink.redirectURLTitle}</span>
                        </a>
                        <a href={data.quickLinks[1].hyperlink.redirectURL} className="home-intro__quick-link" onClick={() => trackMenuClick('Special Offers')}>
                            <MdOutlineSell size="20" className="home-intro__quick-link-icon" aria-label={data.quickLinks[1].hyperlink.seoTitle} />
                            <span className="home-intro__quick-link-text">{data.quickLinks[1]?.hyperlink.redirectURLTitle}</span>
                        </a>
                        <a href={data.quickLinks[2].hyperlink.redirectURL} className="home-intro__quick-link" onClick={() => trackMenuClick('Explore Croatia')}>
                            <MdOutlineExplore size="20" className="home-intro__quick-link-icon" aria-label={data.quickLinks[2].hyperlink.seoTitle} />
                            <span className="home-intro__quick-link-text">{data.quickLinks[2]?.hyperlink.redirectURLTitle}</span>
                        </a>
                        <a href={data.quickLinks[3].hyperlink.redirectURL} className="home-intro__quick-link home-intro__quick-link--ai" onClick={() => trackMenuClick('AI Search')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <mask id="mask0_7717_847" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                    <rect width="20" height="20" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_7717_847)">
                                    <path d="M4.0625 17.0208L3 15.9583L9.08333 9.87501L5.5 9.00001L9.375 6.58334L9.04167 2.02084L12.5417 4.95834L16.75 3.25001L15.0417 7.47918L18 10.9583L13.4381 10.625L11.0208 14.5208L10.1458 10.9375L4.0625 17.0208ZM4.5 7.00001L3 5.50001L4.5 4.00001L6 5.50001L4.5 7.00001ZM11.6042 10.6875L12.625 9.06251L14.5417 9.20834L13.306 7.74584L14.0269 5.95834L12.2556 6.68751L10.7917 5.45834L10.9375 7.37501L9.29167 8.38314L11.1531 8.83584L11.6042 10.6875ZM14.5 17L13 15.5L14.5 14L16 15.5L14.5 17Z" fill="#EBF8FE" />
                                </g>
                            </svg>
                            <span className="home-intro__quick-link-beta-text">BETA</span>
                            <span className="home-intro__quick-link-text">{data.quickLinks[3].hyperlink.redirectURLTitle}</span>
                        </a>
                    </DragScrollWrapper>
                </div>
                <div className="home-intro__content-top-right">
                    <picture>
                        <source media="(max-width: 991.98px)" srcSet={data.mainImage.mobile.sourceURL} width="375" height="135" />
                        <img loading="eager" className="home-intro__image" src={data.mainImage.desktop.sourceURL} alt={data.mainImage.desktop.altText} width="436" height="316" />
                    </picture>
                </div>
            </div>
            {children}
        </div>
    );
}
